import { JsonEditor as JER, JsonEditorProps } from 'json-edit-react';
export const JsonEditor = (props: JsonEditorProps) => {
  return <JER restrictAdd restrictDelete restrictEdit collapse stringTruncate={15} {...props} />;
};
